import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .block-wrapper {
      padding: 0;
    }

    :host {
      --main-carousel-img-height: calc(370rem / var(--default-rem-px-count));
      --selected-variant-padding-width: 2px;
      --selected-variant-border-width: 1px;
      --hero-image-column-start: 2;
      --hero-image-column-end: 8;
      --hero-image-grid-column: var(--hero-image-column-start) /
        var(--hero-image-column-end);
      --text-content-column-start: 2;
      --text-content-column-end: 8;
      --text-content-grid-column: var(--text-content-column-start) /
        var(--text-content-column-end);
      --cta-button-column-start: var(--text-content-column-start);
      --cta-button-column-end: var(--text-content-column-end);
      --cta-button-grid-column: var(--cta-button-column-start) /
        var(--cta-button-column-end);
    }

    :host .block-grid {
      grid-template-rows:
        repeat(10, auto)
        var(--bottom-padding-height)
        [last-line];
    }

    .all-patterns-btn {
      grid-column: 1 / 8;
      grid-row: 1;
      place-self: start center;
      width: 100%;
      display: flex;
      align-items: center;
      min-height: 2.5em;
      border-bottom: 1px solid #c0c0c0;
      margin-bottom: calc(15em / var(--default-rem-px-count));
    }

    .title-header {
      grid-column: var(--text-content-grid-column);
      grid-row: 2;
      margin-bottom: calc(14em / var(--default-rem-px-count));
    }

    .block-label {
      padding-bottom: calc(15em / var(--default-rem-px-count));
    }

    .carousel-hero {
      grid-column: var(--hero-image-grid-column);
      grid-row: 3;
    }

    .variants-wrapper {
      grid-column: var(--text-content-grid-column);
      grid-row: 4;
      padding-bottom: calc(50em / var(--default-rem-px-count));
      display: flex;
      flex-direction: column;
    }

    .description {
      grid-column: var(--text-content-grid-column);
      grid-row: 5;
    }

    .cta-btns {
      grid-column: 2 / 6;
      grid-row: 6;
      margin-bottom: 2.5em;
      display: inherit;
      gap: calc(24em / var(--default-rem-px-count));

      cta-button {
        max-width: calc(200em / var(--default-rem-px-count));
      }
    }

    .visualize-btn.visualize-btn-mobile {
      width: 100%;
    }

    .visualize-btn.visualize-btn-desktop {
      grid-row: 4;
      grid-column: 11 / 13;
      width: 100%;
    }

    material-details-block {
      grid-column: 2 / 8;
      grid-row: 9;
    }

    material-details-block.under-product-details {
      grid-row: 10;
    }

    product-details-block {
      grid-column: 2 / 8;
      grid-row: 9;
    }

    .visualize-btn-mobile {
      display: inherit;
    }

    .visualize-btn-desktop {
      display: none;
    }

    #sticky-hero-wrapper-mobile {
      position: fixed;
      left: 0;
      right: 0;
      background-color: #ffffff;
      display: inline-grid;
      grid-template-columns: 3fr 4fr;
      gap: 1em;
      padding: var(--between-column-padding);
      padding-bottom: 1em;
      z-index: 100;
      border-bottom: 1px solid #ccc;
    }

    .hide-sticky-wrapper {
      display: none !important;
    }

    .carousel-hero-content-wrapper {
      display: flex;
      flex-direction: column;
    }

    .sticky-header-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .sticky-header-content > p.image-caption {
      padding-top: calc(20em / var(--default-rem-px-count));
    }

    .carousel-img-sticky {
      max-height: calc(220em / var(--default-rem-px-count));
      max-width: 100%;
      margin: auto;
    }

    #hero-wrapper-mobile-walter > .carousel-hero-image {
      height: calc(220em / var(--default-rem-px-count));
    }

    .barrels {
      grid-column: var(--text-content-grid-column);
      grid-row: 7;
    }

    .stupid-spacer {
      grid-row: 8;
    }

    .carousel-images {
      display: none;
    }

    .carousel-height {
      display: block;
    }

    .description {
      padding-bottom: calc(30em / var(--default-rem-px-count));
    }

    .all-patterns-btn {
      padding-left: calc(4em / var(--default-rem-px-count));
    }

    .all-patterns-btn img {
      transform: rotate(180deg);
      height: calc(8em / var(--default-rem-px-count));
      width: calc(8em / var(--default-rem-px-count));
    }

    .all-patterns-btn p {
      padding-left: calc(8em / var(--default-rem-px-count));
      margin-bottom: calc(-1em / var(--default-rem-px-count));
    }

    .carousel-images .image {
      margin-bottom: 1em;
      margin-right: 1px;
    }

    .imajize-overlay {
      position: relative;
      display: block;

      .overlay {
        position: absolute;
        height: auto;
        pointer-events: none;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 48px !important;
      }
    }

    .carousel-images .image img {
      width: calc(
        100% -
          (
            2 *
              (
                var(--selected-variant-padding-width) +
                  var(--selected-variant-border-width)
              )
          )
      );
    }

    .selected-image {
      padding: var(--selected-variant-padding-width);
      border: var(--selected-variant-border-width) solid #222222;
    }

    #download-icon {
      display: none;
    }

    .carousel-bottom-row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: calc(18em / var(--default-rem-px-count));
      padding-top: calc(7em / var(--default-rem-px-count));
      border-top: 1px solid #c0c0c0;
    }

    .carousel-arrow {
      position: absolute;
      z-index: 50; /* ensure it's above loading state */
    }

    .carousel-arrow.left-arrow {
      left: 0;
      top: calc(50% - calc(20em / var(--default-rem-px-count)));
    }

    .carousel-arrow.right-arrow {
      right: 0;
      top: calc(50% - calc(20em / var(--default-rem-px-count)));
    }

    .carousel-arrow {
      cursor: pointer;
      width: calc(40em / var(--default-rem-px-count));
      height: calc(40em / var(--default-rem-px-count));
      display: flex;
      align-items: center;
      justify-content: center;
      margin: calc(5em / var(--default-rem-px-count));
    }

    .carousel-arrows-sticky {
      width: 100%;
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: calc(50% - calc(20em / var(--default-rem-px-count)));
    }

    .carousel-arrow img {
      width: calc(9em / var(--default-rem-px-count));
      height: calc(18em / var(--default-rem-px-count));
    }

    .carousel-bottom-row {
      display: flex;
      justify-content: space-between;
    }

    .carousel-bottom-row span {
      justify-content: right;
    }

    .left-arrow {
      transform: rotate(180deg);
    }

    .carousel-bottom-row span img {
      width: calc(12em / var(--default-rem-px-count));
    }

    .image-caption {
      width: 100%;
      padding-top: calc(6em / var(--default-rem-px-count));
    }

    .not-selected-image {
      padding: 3px;
    }

    .carousel-hero-image {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: 100%;
      margin: 0 auto;
      position: relative;
      height: var(--main-carousel-img-height);
    }

    .loading-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10; /* ensure it's above image but below arrows */
    }

    .loading-spinner {
      width: 40px;
      height: 40px;
    }

    .carousel-img {
      max-height: var(--main-carousel-img-height);
      max-width: 100%;
      margin: auto;
    }

    .variants-header {
      font-size: calc(12em / var(--default-rem-px-count));
      letter-spacing: -0.21px;
      font-weight: 500;
      padding-bottom: calc(15em / var(--default-rem-px-count));
    }

    .variants {
      max-width: 100%;
      display: inline-grid;
      gap: 2%;
      grid-template-columns: repeat(4, 23.5%);
    }

    .variant span img {
      width: 100%;
    }

    .variant-name {
      font-size: calc(10em / var(--default-rem-px-count));
      letter-spacing: -0.15px;
      padding-top: 2px;
      padding-left: calc(
        var(--selected-variant-padding-width) +
          var(--selected-variant-border-width)
      );
      line-height: 1.3em;
      max-height: calc(14em / var(--default-rem-px-count));
    }

    .selected-variant {
      padding: var(--selected-variant-padding-width);
      border: var(--selected-variant-border-width) solid #222222;
    }

    .selected-variant + .variant-name {
      font-weight: 500;
    }

    .not-selected-variant {
      padding: calc(
        var(--selected-variant-padding-width) +
          var(--selected-variant-border-width)
      );
    }

    .barrels {
      font-size: calc(14em / var(--default-rem-px-count));
      letter-spacing: -0.21px;
    }

    .hide-on-mobile {
      display: none;
    }

    @media (min-width: 600px) {
      :host {
        --main-carousel-img-height: calc(420em / var(--default-rem-px-count));
        --hero-image-column-start: 3;
        --hero-image-column-end: 9;
        --text-content-column-start: 9;
        --text-content-column-end: 14;
        --cta-button-column-end: 13;
      }

      :host .block-grid {
        grid-template-rows:
          minmax(var(--top-padding-height), auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--bottom-padding-height)
          [last-line];
      }

      .all-patterns-btn {
        grid-column: 2 / 13;
        grid-row: 1;
        place-self: start;
        border-bottom: none;
        width: auto;
        padding-left: 0px;
        margin-top: calc(20em / var(--default-rem-px-count));
      }

      .title-header {
        grid-row: 2;
      }

      .carousel-hero {
        grid-row: 2 / 8;
        position: relative;
        width: 100%;
      }

      .variants-wrapper {
        grid-row: 4;
        padding-bottom: calc(40em / var(--default-rem-px-count));
      }

      .description {
        grid-row: 3;
      }

      .cta-btns {
        grid-row: 5;
        grid-column: 9 / 12;
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: calc(24em / var(--default-rem-px-count)) 0;
        justify-content: space-between;
      }

      /* If .variants-wrapper does NOT exist, move .cta-btns to row 4 */
      .block-grid:not(:has(.variants-wrapper)) .cta-btns {
        grid-row: 4 !important;
      }

      .cta-btns > cta-text-with-icon {
        max-width: 100%;
        min-width: calc(50% - calc(var(--between-column-padding) / 2));
      }

      .full-width {
        width: 100%;
      }

      .cta-btn-row {
        width: 100%;
        display: inline-grid;
        grid-template-columns: [mat-header] 1fr [mat-value] 1fr [end];
        gap: 0px 2em;
      }

      .cta-btn-row .visualize-btn.visualize-btn-desktop {
        grid-column: unset;
        grid-row: unset;
      }

      cta-button {
        display: flex;
      }

      .barrels {
        grid-row: 6;
      }

      .block-grid:not(:has(.variants-wrapper)) .barrels {
        grid-row: 5 !important;
      }

      .carousel-images {
        grid-column: 2;
        grid-row: 2 / 8;
        display: unset;
      }

      material-details-block {
        grid-column: 2 / 14;
        grid-row: 9;
      }

      material-details-block.under-product-details {
        grid-row: 10;
      }

      product-details-block {
        grid-column: 2 / 14;
        grid-row: 9;
      }

      .carousel-images-sticky {
        position: -webkit-sticky;
        position: sticky;
        top: calc(30em / var(--default-rem-px-count));
        left: 0;
        align-self: start;
        overflow: auto;
      }

      #download-icon {
        display: flex;
        margin-top: calc(10em / var(--default-rem-px-count));

        p {
          margin-right: 8px;
          font-size: calc(12rem / var(--default-rem-px-count));
          text-wrap: nowrap;
          font-weight: 500;
        }
      }

      horizontal-rule {
        grid-column: 2 / 14;
        grid-row: 1 / last-line;
      }

      .carousel-hero > .carousel-hero-content-wrapper {
        position: -webkit-sticky;
        position: sticky;
        top: calc(30em / var(--default-rem-px-count));
        left: 0;
        display: flex;
        flex-direction: column;
      }

      .carousel-hero-image:hover > .carousel-arrow {
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.4);
      }

      .carousel-hero-image:hover > .carousel-img {
        cursor: zoom-in;
      }

      .carousel-hero-image:hover.zoom-enabled {
        overflow: hidden;
      }

      .carousel-hero-image:hover.zoom-enabled > .carousel-img {
        position: absolute;
        top: 0;
        left: 0;
        max-height: unset;
        max-width: unset;
        cursor: zoom-out;
      }

      .relative-position {
        position: relative;
      }

      .variants {
        gap: calc(15em / var(--default-rem-px-count));
        grid-template-columns: repeat(
          6,
          minmax(0, calc(100em / var(--default-rem-px-count)))
        );
      }

      .hide-on-mobile {
        display: inherit;
      }
    }

    @media (min-width: 1024px) {
      :host {
        --text-content-column-end: 14;
        --cta-button-column-end: 12;
        --main-carousel-img-height: calc(520em / var(--default-rem-px-count));
      }

      .carousel-img-sticky {
        max-height: 100%;
      }
    }

    @media (min-width: 1200px) {
      :host {
        --main-carousel-img-height: calc(860em / var(--default-rem-px-count));
      }

      .cta-btns {
        flex-direction: row;
      }

      .cta-btns {
        grid-column: 9 / 13;
      }

      cta-button {
        width: calc(200em / var(--default-rem-px-count));
      }

      .visualize-btn-mobile {
        display: none;
      }

      .visualize-btn-desktop {
        display: inherit;
      }
    }

    /*
        This is the CSS context for "printing" the details as a PDF.
        I do not know the exact width but it uses headless chrome as "Letter"
        format. (puppeteer Page.pdf({}))
      */
    @media print {
      :host {
        --hero-image-column-start: 2;
        --main-carousel-img-height: calc(370em / var(--default-rem-px-count));
      }

      :host .block-grid {
        grid-template-rows:
          max-content
          min-content
          min-content
          repeat(5, auto)
          max-content
          max-content
          [last-line];
        height: 100%;
      }

      .block-wrapper {
        width: 7.5in;
        height: 9.5in;
        margin: 0.5in;
        margin-bottom: 1in;
      }

      .carousel-hero {
        grid-column: 2 / 8;
      }

      .description {
        grid-column: 9 / 13;
        font-size: 10px;
        letter-spacing: -0.05px;
        padding-bottom: 20px;
      }

      .title-header {
        grid-column: 9 / 14;
        padding-bottom: 20px;
      }

      .barrels {
        grid-row: 4;
        grid-column: 9 / 14;
      }

      h1 {
        font-size: 24px;
        letter-spacing: -0.54px;
        line-height: 28px;
      }

      p,
      .font-size-small {
        font-size: 9px;
        letter-spacing: -0.05px;
        line-height: 12px;
      }

      .footer-logo {
        grid-row: 9;
        grid-column: 2 / 8;
        height: 22px;
        display: flex;
        align-self: end;
      }

      .footer-info {
        grid-row: 9;
        grid-column: 9 / 14;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }
    }
  `,
];
